import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "./ui/button";
import { AlcDrawer, DrawerDescription, DrawerTitle } from "./ui/drawer";
import { Form, FormField, FormItem, FormLabel, FormMessage } from "./ui/form";
import { Input } from "./ui/input";

const FormSchema = z
  .object({
    time: z.string().min(1),
    date: z.string().min(1),
  })
  .refine(
    (data) => {
      const timestamp = new Date(`${data.date}T${data.time}`).getTime();
      return timestamp <= Date.now();
    },
    {
      message: "Nelze přidat v budoucnosti.",
      path: ["time"],
    }
  );

const LogTimeSelectionDrawer = ({
  isOpen,
  setIsOpen,
  onSubmit: _onSubmit,
  actionLabel,
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: (data: { date: number }) => void;
  actionLabel: string;
}) => {
  const form = useForm<z.infer<typeof FormSchema>>({
    mode: "onBlur",
    resolver: zodResolver(FormSchema),
    defaultValues: {
      time: new Date().toTimeString().split(":").slice(0, 2).join(":"),
      date: `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${new Date().getDate().toString().padStart(2, "0")}`,
    },
  });

  async function onSubmit(data: z.infer<typeof FormSchema>) {
    const timestamp = new Date(`${data.date}T${data.time}`).getTime();
    _onSubmit({ date: timestamp });
  }

  return (
    <AlcDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      asChild
      header={
        <>
          <DrawerTitle className="text-center">Přidání v minulosti</DrawerTitle>
          <DrawerDescription asChild>Vyber datum a čas.</DrawerDescription>
        </>
      }
    >
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          <FormField
            control={form.control}
            name="date"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Datum</FormLabel>
                <Input
                  type="date"
                  autoComplete="date"
                  id="date"
                  className="justify-center"
                  {...field}
                />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="time"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Čas</FormLabel>
                <Input
                  type="time"
                  className="justify-center"
                  autoComplete="time"
                  id="time"
                  {...field}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <div>
            <Button type="submit" className="w-full">
              {actionLabel}
            </Button>
          </div>
        </form>
      </Form>
    </AlcDrawer>
  );
};

export default LogTimeSelectionDrawer;
